import { render, staticRenderFns } from "./SerialHead.vue?vue&type=template&id=34c9646d&scoped=true"
import script from "./SerialHead.vue?vue&type=script&lang=js"
export * from "./SerialHead.vue?vue&type=script&lang=js"
import style0 from "./SerialHead.vue?vue&type=style&index=0&id=34c9646d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c9646d",
  null
  
)

export default component.exports